export default {
  "Loop as a GIF": "Loop als een GIF",
  "without sound": "zonder geluid",
  "Final output duration": "Uiteindelijke uitvoerduur",
};
